import { useEffect } from 'react';

import { SessionStorageManager, SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES, paymentRoutes } from '@atlas/routing';

import history from 'components/Layout/history';
import { DEPOSIT_FAILED, REDIRECT_DATA_AFTER_DEPOSIT } from 'src/common/constants';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { payment } = clientProfileRoutes;
const { deposit } = paymentRoutes;

const getDepositFailedData = ({ alternativePmEnabled = false, pmId = null } = {}) =>
  JSON.stringify({
    alternativePmEnabled: !!alternativePmEnabled,
    pmId,
  });

const useRedirectAfterDeposit = () => {
  useEffect(() => {
    const isDepositFailed =
      new URLSearchParams(window.location.search).get('deposit_failed') === 'true';

    const redirectData = SessionStorageManager.getItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (!redirectData) {
      if (!isDepositFailed) return;

      SessionStorageManager.setItem(DEPOSIT_FAILED, getDepositFailedData());
      const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
      window.location.href = `${clientProfilePath}/${payment}/${deposit}`;
      return;
    }

    const { alternativePmEnabled, expirationTime, pmId, url } = JSON.parse(redirectData);

    SessionStorageManager.removeItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (Date.now() < expirationTime && url) {
      if (isDepositFailed) {
        SessionStorageManager.setItem(
          DEPOSIT_FAILED,
          getDepositFailedData({ alternativePmEnabled, pmId }),
        );
      }
      window.location.href = url;
      return;
    }

    if (isDepositFailed) {
      const params = new URLSearchParams(window.location.search);
      params.delete('deposit_failed');
      const newSearch = params.toString();
      const queryString = newSearch ? `?${newSearch}` : '';
      history.replace(`${window.location.pathname}${queryString}`);
    }
  }, []);
};

export default useRedirectAfterDeposit;
